module.exports = __webpack_public_path__ + "img/wu.4f6c53e0.png";